import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const WS_URL = `${BACKEND_URL.replace(/^http/, "ws")}/api/ws/chat`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("odl_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    // Never bounce-redirect during identity bootstrap or login itself.
    const isAuthMe = url.includes("/auth/me") || url.includes("/auth/login");
    if (status === 401 && !isAuthMe) {
      const hadToken = !!localStorage.getItem("odl_token");
      if (hadToken) {
        localStorage.removeItem("odl_token");
        localStorage.removeItem("odl_user");
        if (!window.location.pathname.includes("/login")) {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(err);
  }
);

export function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem("odl_user") || "null");
  } catch {
    return null;
  }
}
export function getStoredToken() {
  return localStorage.getItem("odl_token");
}
export function setSession(token, user) {
  localStorage.setItem("odl_token", token);
  localStorage.setItem("odl_user", JSON.stringify(user));
}
export function clearSession() {
  localStorage.removeItem("odl_token");
  localStorage.removeItem("odl_user");
}
